import { render } from "./ProfileEditView.vue?vue&type=template&id=35fa01a8&scoped=true"
import script from "./ProfileEditView.vue?vue&type=script&lang=js"
export * from "./ProfileEditView.vue?vue&type=script&lang=js"

import "./ProfileEditView.vue?vue&type=style&index=0&id=35fa01a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fa01a8"]])

export default __exports__